export const reducer = (state = {}, action) => {
    switch (action.type) {
        case 'SEND_TERMINAL_COMMAND':
            return {
                ...state,
                [action.device_id]: [
                    ...(state[action.device_id] ?? []),
                    {
                        request_id: action.request_id,
                        request_time: Date.now(),
                        request: action.text,
                    },
                ],
            };
        case 'GOT_TERMINAL_RESPONSE':
            return {
                ...state,
                [action.device_id]: (state[action.device_id] ?? []).map((item) => {
                    if (!('request_id' in item) ||
                        item.request_id !== action.request_id)
                        return item;
                    return {
                        ...item,
                        ok: action.ok,
                        response: action.text,
                        response_time: Date.now(),
                        failure: action.failure,
                    };
                }),
            };
        case 'APPLY_DEBUG_TEXT_MESSAGE':
            return {
                ...state,
                [action.device_id]: [
                    ...(state[action.device_id] ?? []),
                    {
                        ok: true,
                        response: action.text,
                        response_time: Date.now(),
                    },
                ].slice(-150),
            };
        default:
            return state;
    }
};
